/* eslint-disable prettier/prettier */
/* eslint-disable */

import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import Collapse from "@mui/material/Collapse";
import Icon from "@mui/material/Icon";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function DefaultNavbarDropdown({
  name,
  icon,
  children,
  collapseStatus,
  light,
  href,
  route,
  collapse,
  ...rest
}) {
  const location = useLocation();

  const isCurrentRoute = location.pathname === route;
  if (isCurrentRoute) return null;

  const linkComponent = {
    component: "a",
    href,
    target: "_blank",
    rel: "noreferrer",
  };

  const routeComponent = {
    component: Link,
    to: route,
  };

  return (
    <>
      <MKBox
        {...rest}
        mx={1}
        my={0.5}
        p={1}
        display="flex"
        flexDirection="column"
        alignItems="center"
        color="white"
        sx={{
          cursor: "pointer",
          userSelect: "none",
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          backdropFilter: "blur(4px)",
          borderRadius: "8px",
          border: "1px solid rgba(255, 255, 255, 0.2)",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            transform: "scale(1.02)",
            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.2)",
            border: "1px solid #ff4081",
          },
          "&:active": {
            background: "linear-gradient(45deg, #9c1b3f, #004d6b)",
            boxShadow: "none",
          },
        }}
        {...(route && routeComponent)}
        {...(href && linkComponent)}
      >
        <MKTypography
          variant="h5"
          lineHeight={1}
          color="white"
          sx={{
            alignSelf: "center",
            transition: "all 0.2s ease-in-out",
            textAlign: "center",
            mb: 0.3,
          }}
        >
          {icon}
        </MKTypography>
        <MKTypography
          variant="caption"
          fontWeight="bold"
          textTransform="capitalize"
          color="white"
          sx={{
            transition: "all 0.2s ease-in-out",
            textAlign: "center",
            mb: 0.3,
          }}
        >
          {name}
        </MKTypography>
        {collapse && (
          <Icon sx={{ fontWeight: "normal", verticalAlign: "middle", color: "white", fontSize: "0.8rem" }}>
            keyboard_arrow_down
          </Icon>
        )}
      </MKBox>

      {children && (
        <Collapse in={Boolean(collapseStatus)} timeout={300} unmountOnExit>
          <MKBox
            sx={{
              backgroundColor: "rgba(0, 0, 0, 0.15)",
              borderRadius: "5px",
              boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.2)",
              marginTop: "3px",
              padding: "6px 12px",
              transition: "all 0.2s ease-in-out",
            }}
          >
            {children}
          </MKBox>
        </Collapse>
      )}
    </>
  );
}

DefaultNavbarDropdown.defaultProps = {
  children: false,
  collapseStatus: false,
  light: false,
  href: "",
  route: "",
};

DefaultNavbarDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  children: PropTypes.node,
  collapseStatus: PropTypes.bool,
  light: PropTypes.bool,
  href: PropTypes.string,
  route: PropTypes.string,
  collapse: PropTypes.bool.isRequired,
};

export default DefaultNavbarDropdown;
